module.exports = require('./readable').Transform



// WEBPACK FOOTER //
// webpack:///node_modules/readable-stream/transform.js